// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getStorage } from '../utils/functions/localstorage';

const baseQuery = fetchBaseQuery({
  baseUrl: `${process.env.REACT_APP_API_URL_admin}/matchstatement`,
  prepareHeaders: (headers) => {
    const token = getStorage('token');
    // If we have a token set in state, let's assume that we should be passing it.
    if (token) {
      headers.set('authorization', `Bearer ${token}`);
    }

    return headers;
  },
});

export const approvedDataApi = createApi({
  reducerPath: 'approvedDataApi',
  baseQuery,
  endpoints: (builder) => ({
    AppovedData: builder.query({
      query: (q) => {
        const params = new URLSearchParams({
          page: String(q.page),
          size: String(q.size),
          search: q.search || '',
          searchUploadRef: q.searchUploadRef || '',
          sortBy: q.sortBy || 'upload_ref',
          sortOrder: q.sortOrder || 'desc',
        });

        return `get-approved-data?${params.toString()}`;
      },
    }),
  }),
});

export const {
 useAppovedDataQuery
} = approvedDataApi;
// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
